import apiService from './apiService';

const api = apiService();

export interface McpTokenStatus {
  success: boolean;
  connected: boolean;
  tokens: Array<{
    id: string;
    label: string;
    created_at: string;
    last_used_at: string | null;
  }>;
}

export interface McpTokenIssued {
  success: boolean;
  token: string; // one-time plaintext, only returned at issuance
  id: string;
  created_at: string;
}

const McpService = {
  async status(): Promise<McpTokenStatus> {
    const { data } = await api.get<McpTokenStatus>('/mcp/token/status');
    return data;
  },
  async issue(): Promise<McpTokenIssued> {
    const { data } = await api.post<McpTokenIssued>('/mcp/token');
    return data;
  },
  async revoke(): Promise<{ success: boolean }> {
    const { data } = await api.delete<{ success: boolean }>('/mcp/token');
    return data;
  },
};

export default McpService;
